module.exports = __webpack_public_path__ + "img/1d7fd51.jpg";